import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const location = useLocation();

  // When returning from Filter we restore scroll; otherwise scroll to top on route change
  useEffect(() => {
    const restoreScroll = location.state?.restoreScroll;
    if (typeof restoreScroll === "number" && restoreScroll >= 0) {
      window.scrollTo(0, restoreScroll);
    } else {
      window.scrollTo(0, 0);
    }
  }, [location.pathname, location.state?.restoreScroll]);

  return null;
}